module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Ad-St_1.c17d1e4e.jpg";